import PhotoUploadCrop from "components/File/PhotoUploadCrop";
import { Avatar, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Chip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import DText from "components/common/DText";
import JText from "components/common/DText";

const EmployeeActions = ({ data, onEdit }) => {
    return (
        <Tooltip title="Edit employee">
            <IconButton
                size="small"
                onClick={(event) => {
                    event.stopPropagation();
                    onEdit(data);
                }}
            >
                <EditIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};

const employeeColumnDefs = ({ onEdit, linkQuery, currentPersonId }) => [
    {
        headerName: "Employee",
        field: "fullName",
        flex: 3,
        minWidth: 260,
        cellRenderer: (params) => {
            const employee = params.data;

            if (!employee) {
                return null;
            }

            const photo = employee.photoFileName ? (
                <PhotoUploadCrop
                    value={employee?.PhotoFileName}
                    sourceImage={employee?.photoFileName}
                    readOnly
                    size={40}
                />
            ) : (
                <Avatar
                    sx={{
                        width: 40,
                        height: 40
                    }}
                >
                    {employee.firstName?.[0]}
                </Avatar>
            );

            return (
                /*<Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    }}
                >
                    <GridContainer sx={{ mb: 1 }}>
                        <GridItem>{photo}</GridItem>
                        <GridItem>
                            <GridContainer spacing={0} direction="column">
                                <GridItem> {employee.fullName}</GridItem>
                                <GridItem> {employee.fullName}</GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </Box>*/
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: "4px"
                    }}
                >
                    {photo}

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            lineHeight: 1.2
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                lineHeight: 1.2
                            }}
                        >
                            <DText
                                link
                                component="a"
                                //href={linkQuery(employee)}
                                noUnderlined
                                lg
                                uppercase
                                onClick={() => onEdit(employee)}
                                // target="_blank"
                            >
                                {employee.fullName}
                                {currentPersonId === employee.id && (
                                    <DText sm orange halfPaddingLeft>
                                        (Me)
                                    </DText>
                                )}
                            </DText>
                        </Typography>

                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{
                                lineHeight: 1.2
                            }}
                        >
                            Employee #{employee.employee?.employeeCode || "—"}
                        </Typography>
                    </Box>
                </Box>
            );
        }
    },
    {
        headerName: "Pay Class",
        field: "payClassName",
        flex: 1.5,
        minWidth: 150,
        valueFormatter: (params) => params.value || "—"
    },
    {
        headerName: "Status",
        field: "employmentStatusName",
        flex: 1.3,
        minWidth: 130,
        cellRenderer: (params) => {
            if (!params.value) {
                return "—";
            }

            return (
                <Chip label={params.value} size="small" variant="outlined" />
            );
        }
    },
    {
        headerName: "Date Hired",
        field: "employee.dateHired",
        flex: 1.2,
        minWidth: 130,

        valueGetter: (params) => {
            return params.data?.employee?.dateHired || null;
        },

        valueFormatter: (params) => {
            if (!params.value) {
                return "—";
            }

            return new Date(params.value).toLocaleDateString();
        },

        comparator: (dateA, dateB) => {
            const timeA = dateA ? new Date(dateA).getTime() : 0;
            const timeB = dateB ? new Date(dateB).getTime() : 0;

            return timeA - timeB;
        }
    },
    {
        headerName: "",
        field: "actions",
        width: 65,
        minWidth: 60,
        // maxWidth: 60,
        flex: 0,
        sortable: false,
        resizable: false,
        filter: false,
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        pinned: "left",
        lockPinned: true,
        cellRenderer: (params) => (
            <EmployeeActions data={params.data} onEdit={onEdit} />
        )
    }
];

export default employeeColumnDefs;
